import { useIntl } from 'react-intl';
import { useLoaderData, useNavigate } from 'react-router-dom';
import BackButton from '@luna-protocol/core/src/components/BackButton/BackButton';
import Banner from '@luna-protocol/core/src/components/Banner/Banner';
import Button from '@luna-protocol/core/src/components/Button/Button';
import { Spinner } from '@luna-protocol/core/src/components/Spinner/Spinner';
import LineBreak from '@luna-protocol/core/src/components/LineBreak/LineBreak';
import messages from './ProcessingMFA.messages.ts';
import { ProcessingMFALoaderData } from './processingMFALoader.ts';
import './ProcessingMFA.scss';

const ProcessingMFA = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { mfaError } = useLoaderData() as ProcessingMFALoaderData;

  return (
    <>
      <BackButton path="/login" inverted />
      <Banner>
        {!mfaError && (
          <>
            <Spinner />
            <LineBreak />
          </>
        )}
        {mfaError ? (
          <>
            <p className="processing-message">{formatMessage(messages.mfaError)}</p>
            <div className="processing-actions">
              <Button type="button" onClick={() => navigate('/login')} testId="processing-mfa-return-login">
                {formatMessage(messages.returnToLogin)}
              </Button>
            </div>
          </>
        ) : (
          <p className="processing-message">{formatMessage(messages.processing)}</p>
        )}
      </Banner>
    </>
  );
};

export default ProcessingMFA;
